/* eslint-disable indent */
/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
/* eslint-disable @typescript-eslint/camelcase */
import {
  Avatar,
  ButtonBase,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  makeStyles,
  Paper,
  Switch,
  Tooltip,
  Typography,
  TextField,
  Box,
} from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';
import PaletteIcon from '@material-ui/icons/Palette';
import Permission from 'components/ValidPermission';
import EditIcon from '@material-ui/icons/Edit';
import FormBox from 'components/FormBox';
import MultipleSelect from 'components/MultipleSelect';
import ErrorIcon from '@material-ui/icons/Error';
import { Formik } from 'formik';
import i18n from 'i18n';
import { getAllCompaniesRequest } from 'modules/companies/actions';
import { CompanyFields } from 'modules/companies/interfaces';
import { modalClose, modalOpen } from 'modules/modal/actions';
import { ModalFields } from 'modules/modal/interfaces';
import { LDAPTestRequest } from 'modules/partners/actions';
import { PartnerFormFields } from 'modules/partners/interfaces';
import React from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import GenericForm from 'skyone-lib/lib/GenericForm';
import ApplicationState from 'store/interfaces';
import { useFilePicker } from 'use-file-picker';
import { applyI18n } from 'utils/helpers';
import Button from 'components/Button';
import Loading from 'components/Loading';
import { CompanyData, RolesEnum } from 'modules/authenticate/interfaces';
import clsx from 'clsx';
import {
  cloudFields,
  emailFields,
  pluginFields,
  screenFields,
} from './formFields';
import { initial, initialQuery, mapLabels } from './helperValues';
import validationSchema from './schema';
import styles from './styles';
import CompanyList from './companyList';
import ADConfigFields from './adConfigFields';
import UseNewFrontConfiguration from './UseNewFrontConfiguration';
import DisableRecaptcha from './DisableRecaptcha';

const useStyles = makeStyles(styles);

export interface CompanyFieldsProps {
  company_name?: string;
  company_uuid?: string;
}

interface FormProps {
  companyDetails: CompanyFields | null;
  isLoading: boolean;
  initialValues?: PartnerFormFields | null;
  loadingEdit?: boolean;
  isEdit?: boolean;
  ldapLoading: boolean;
  companySelected: CompanyData | null;
  role?: RolesEnum;
  onSubmit: (values: any, form: any) => void;
  onReset?: () => void;
  onDelete?: () => void;
  getAllCompaniesRequest: (props) => void;
  LDAPTestRequest: (props) => void;
  modalOpen: (props: ModalFields) => void;
  modalClose: () => void;
}

interface SwitchComponentProps {
  id?: string;
  label: string | React.ReactElement;
  isChecked: boolean;
  children?: React.ReactNode;
  hidden?: boolean;
  explanationHover?: React.ReactNode;
  borderText: string;
  disabled?: boolean;
  onChange: (e: any, value: any) => void;
}

function SwitchComponent({
  id,
  label,
  isChecked,
  children,
  hidden,
  explanationHover,
  borderText,
  disabled,
  onChange,
}: SwitchComponentProps) {
  const classes = useStyles();
  return hidden ? null : (
    <Grid container className={classes.switchRoot}>
      <Grid item xs={12} className={classes.fieldset}>
        <fieldset className={classes.fieldSetSwitchComponents}>
          <FormControlLabel
            classes={{ label: classes.switchLabel }}
            control={
              <Switch
                id={id}
                checked={isChecked}
                onChange={onChange}
                classes={{ colorSecondary: classes.switchChecked }}
                size="small"
                disabled={disabled}
              />
            }
            label={label}
          />
          <legend className={classes.fieldSetSwitchText}>{borderText}</legend>
        </fieldset>
        {!!explanationHover && explanationHover}
      </Grid>
      {!!children && isChecked && children}
    </Grid>
  );
}

const FormPartner = ({
  isLoading,
  initialValues,
  loadingEdit = false,
  isEdit,
  companySelected,
  ldapLoading,
  role,
  companyDetails,
  onSubmit,
  onDelete,
  getAllCompaniesRequest,
  modalOpen,
  LDAPTestRequest,
  modalClose,
}: FormProps) => {
  const classes = useStyles();
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const [
    companyFields,
    setCompanyFields,
  ] = React.useState<CompanyFieldsProps | null>({
    company_name: initialValues?.company_name,
    company_uuid: initialValues?.company_uuid,
  });
  const [haveBoxError, setBoxError] = React.useState(false);
  const [boxErrors, setBoxErrors] = React.useState<Array<'aws' | 'oci'>>([]);
  const [
    hasNewFrontMigrationError,
    setHasNewFrontMigrationError,
  ] = React.useState(false);

  const [query] = React.useState(initialQuery);

  const [openFileSelector, { filesContent }] = useFilePicker({
    readAs: 'DataURL',
    accept: 'image/*',
    multiple: false,
    maxFileSize: 10,
  });

  const setValueFormBox = (setFieldValue, value) => {
    Object.keys(value).forEach(key => {
      setFieldValue(key, value[key]);
    });
  };

  const hasCloud = (arr: Array<any>, value: string) =>
    arr.find(item => item === value);

  React.useEffect(() => {
    getAllCompaniesRequest(query);
  }, [getAllCompaniesRequest, query]);

  React.useEffect(() => {
    setCompanyFields({
      company_name: initialValues?.company_name,
      company_uuid: initialValues?.company_uuid,
    });
  }, [initialValues]);

  React.useEffect(() => {
    if (initialValues) {
      const arr: string[] = [];

      if (initialValues?.cloud_providers.aws.role_arn) arr.push('aws');
      if (initialValues?.cloud_providers?.oci?.compartment_id) arr.push('oci');

      initialValues.use_cloud = arr;

      initialValues.use_email =
        initialValues?.email.subject?.length > 0 ? 'true' : 'false';
      initialValues.use_plugin =
        !!initialValues?.plugin.url_plugin ||
        !!initialValues?.plugin.url_return;
    }
  }, [companyDetails, initialValues]);

  const renderADStatus = LDAPTestResult => {
    if (LDAPTestResult?.global_result === 'success') {
      return (
        <Grid item className={classes.zeroTrustStatusValid}>
          <CheckCircleIcon className={classes.statusZeroTrustIconValid} />
          <Typography className={classes.validZeroTrust}>
            {i18n.t('CONNECTED_SUCCESSFULLY_KEY')}
          </Typography>
        </Grid>
      );
    }

    if (LDAPTestResult?.global_result === 'failed') {
      return (
        <Grid item className={classes.zeroTrustStatusInvalid}>
          <ErrorIcon className={classes.statusZeroTrustIconInvalid} />
          <Typography className={classes.invalidZeroTrust}>
            {i18n.t('CONNECTION_FAILED_KEY')}
          </Typography>
        </Grid>
      );
    }

    return <Grid></Grid>;
  };

  const handleOpenTestResult = LDAPTestResult => {
    modalOpen({
      title: i18n.t('PARTNER_PAGE.CONNECT_TEXT_TITLE_KEY'),
      content: (
        <Grid container>
          <Grid container justify="center" alignItems="center">
            <Grid item>{renderADStatus(LDAPTestResult)}</Grid>
            <Grid container className={classes.resultContainer}>
              {LDAPTestResult?.global_step_results?.map((step, index) => (
                <Grid item className={classes.itemInfoZeroTrust} key={index}>
                  <Typography
                    component="div"
                    className={classes.infoZeroTrustTitle}
                  >
                    {step?.step_result === 'success' ? (
                      <CheckCircleIcon
                        className={classes.statusZeroTrustIconValid}
                      />
                    ) : (
                      <ErrorIcon
                        className={classes.statusZeroTrustIconInvalid}
                      />
                    )}
                    {i18n.t(
                      `LDAP_TEST_RESULT.${step?.step_name.toUpperCase()}`
                    )}
                    <Box
                      display="flex"
                      alignItems="center"
                      className={clsx({
                        [classes.trueOption]: step?.step_result === 'success',
                        [classes.falseOption]: step?.step_result === 'failed',
                      })}
                    ></Box>
                  </Typography>
                  {step?.step_result === 'failed' && (
                    <Grid item className={classes.itemInfoPlatformVersion}>
                      <Typography
                        component="div"
                        className={classes.infoZeroTrustTitle}
                      >
                        {`${i18n.t('DETAILS_KEY')}: `}
                        <Box
                          display="flex"
                          alignItems="center"
                          className={classes.blueOption}
                        >
                          {step?.step_error || '-'}
                        </Box>
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      ),
      footer: (
        <Grid>
          <Button id="cancel-button" variant="outlined" onClick={modalClose}>
            {i18n.t('CLOSE_KEY')}
          </Button>
        </Grid>
      ),
    });
  };

  const handleTestLDAP = (data: any) => {
    LDAPTestRequest({
      values: data,
      partnerUuid: id,
      handleOpenTestResult,
    });
  };

  const updateCloudProviderValues = (
    keys: Array<string>,
    values: typeof initial.cloud_providers
  ) => {
    const arr: typeof values = values;

    if (!keys.includes('aws'))
      Object.keys(values?.aws).forEach(key => (arr.aws[key] = ''));

    if (!keys.includes('oci'))
      Object.keys(values?.oci).forEach(key => (arr.oci[key] = ''));

    return {
      ...values,
      ...arr,
    };
  };

  const haveEmptyFields = (values: any, ignoreKeys?: string[]) =>
    Object.keys(values).some(key => {
      if (ignoreKeys?.includes(key)) return false;
      return values[key] === '' || values[key] === null;
    });

  const handleSubmit = (values: any, form: any) => {
    if (haveBoxError) return;
    const isValidCP = values?.use_cloud.filter(item =>
      haveEmptyFields(values?.cloud_providers[item], ['compartment_id'])
    );
    setBoxErrors(isValidCP);

    if (isValidCP.length > 0) return;

    modalOpen({
      title: i18n.t(
        `PARTNER_PAGE.${isEdit ? 'EDIT_PARTNER_KEY' : 'ADD_NEW_PARTNER_KEY'}`
      ),
      content: i18n.t(
        `PARTNER_PAGE.${
          isEdit ? 'EDIT_PARTNER_QUESTION_KEY' : 'ADD_NEW_PARTNER_QUESTION_KEY'
        }`,
        {
          name: values?.name,
          company: companyFields?.company_name,
        }
      ),
      footer: (
        <Grid>
          <Button
            submitButton
            id="submit-button"
            onClick={() => {
              onSubmit(values, form);
              modalClose();
            }}
          >
            {i18n.t('CONFIRM_KEY')}
          </Button>
          <Button id="cancel-button" variant="outlined" onClick={modalClose}>
            {i18n.t('CANCEL_KEY')}
          </Button>
        </Grid>
      ),
      maxWidth: 'xs',
    });
  };

  return (
    <>
      {!loadingEdit ? (
        <Grid>
          <Grid container className={classes.topContent}>
            <ButtonBase
              id="open-file-selector"
              className={classes.buttonAvatar}
              onClick={openFileSelector}
              disabled
            >
              <Avatar
                variant="rounded"
                src={filesContent[0]?.content}
                className={classes.avatar}
              />
              <EditIcon className={classes.hiddenIcon} />
            </ButtonBase>
          </Grid>

          <Grid container>
            <Formik
              initialValues={
                initialValues || {
                  ...initial,
                  company_uuid: companySelected?.id || '',
                }
              }
              validationSchema={validationSchema(
                !initialValues?.active_directory?.admin_bind_pass
              )}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ setFieldValue, submitForm, errors, values }) => (
                <Grid container spacing={2}>
                  <Grid container alignItems="center">
                    <Grid item className={classes.autocomplete}>
                      <GenericForm
                        fields={values}
                        screenFields={applyI18n(
                          [screenFields[0]],
                          i18n.language
                        )}
                        setFieldValue={setFieldValue}
                        errors={errors}
                        overrideClasses={{
                          selectLabel: { fontSize: 11, fontWeight: 500 },
                        }}
                      />
                    </Grid>

                    <Grid item className={classes.selectorGrid}>
                      <TextField
                        fullWidth
                        id="btn-select-company"
                        label={i18n.t('COMPANY_KEY')}
                        placeholder={i18n.t('CHOOSE_COMPANY_KEY')}
                        value={
                          companyFields?.company_name || companySelected?.name
                        }
                        variant="outlined"
                        className={classes.autocompleteCompany}
                        onClick={() =>
                          modalOpen({
                            title: i18n.t('CHOOSE_COMPANY_KEY'),
                            content: (
                              <CompanyList
                                companyFields={companyFields}
                                setCompanyFields={setCompanyFields}
                                setFieldValue={setFieldValue}
                                companyDetails={companyDetails}
                              />
                            ),
                            maxWidth: 'md',
                            fullWidth: true,
                            footer: (
                              <Grid>
                                <Button
                                  id="cancel-button"
                                  variant="outlined"
                                  onClick={modalClose}
                                >
                                  {i18n.t('CANCEL_KEY')}
                                </Button>
                              </Grid>
                            ),
                          })
                        }
                        InputProps={{ readOnly: true }}
                        InputLabelProps={{ shrink: true }}
                        error={!!errors.company_uuid}
                        helperText={errors.company_uuid}
                      />
                    </Grid>
                  </Grid>
                  <GenericForm
                    fields={values}
                    screenFields={applyI18n(
                      screenFields.slice(1, 3),
                      i18n.language
                    )}
                    setFieldValue={setFieldValue}
                    errors={errors}
                    overrideClasses={{
                      selectLabel: { fontSize: 12, fontWeight: 500 },
                    }}
                  />

                  <Grid item className={classes.autocomplete}>
                    <Grid item>
                      <MultipleSelect
                        {...applyI18n([screenFields[4]], i18n.language)[0]}
                        defaultValue={values?.use_cloud.map(item => ({
                          value: item,
                          label: mapLabels[item],
                        }))}
                        errors={errors}
                        setFieldValue={(key, value) => {
                          setFieldValue(
                            'cloud_providers',
                            updateCloudProviderValues(
                              value,
                              values?.cloud_providers
                            )
                          );
                          setFieldValue(key, value);
                        }}
                        overrideClasses={{
                          selectLabel: { fontSize: 12, fontWeight: 500 },
                        }}
                      />
                    </Grid>
                    {!!values?.use_cloud && (
                      <Grid
                        item
                        container
                        className={classes.cloudProviderCards}
                      >
                        {hasCloud(values?.use_cloud, 'aws') && (
                          <Grid container>
                            <FormBox
                              onError={value => setBoxError(value)}
                              title="Amazon Web Services"
                              fields={applyI18n(cloudFields.aws, i18n.language)}
                              error={boxErrors.includes('aws')}
                              initialValues={{
                                role_arn: values?.cloud_providers.aws.role_arn,
                                external_id:
                                  values?.cloud_providers.aws.external_id,
                                owner_id: values?.cloud_providers.aws.owner_id,
                              }}
                              onSubmit={val => {
                                setFieldValue('cloud_providers.aws', val);
                              }}
                              onCancel={val => {
                                setFieldValue('cloud_providers.aws', val);
                                setFieldValue(
                                  'use_cloud',
                                  values?.use_cloud.filter(
                                    item => item !== 'aws'
                                  )
                                );
                              }}
                            />
                          </Grid>
                        )}
                        {hasCloud(values?.use_cloud, 'oci') && (
                          <Grid container>
                            <FormBox
                              onError={value => setBoxError(value)}
                              title={i18n.t('ORACLE_CLOUD_KEY')}
                              fields={applyI18n(cloudFields.oci, i18n.language)}
                              error={boxErrors.includes('oci')}
                              initialValues={{
                                compartment_id:
                                  values?.cloud_providers.oci.compartment_id,
                                profile_name:
                                  values?.cloud_providers.oci.profile_name,
                              }}
                              onSubmit={val => {
                                setFieldValue('cloud_providers.oci', val);
                              }}
                              onCancel={val => {
                                setFieldValue('cloud_providers.oci', {
                                  ...val,
                                  profile_name: 'DEFAULT',
                                });
                                setFieldValue(
                                  'use_cloud',
                                  values?.use_cloud.filter(
                                    item => item !== 'oci'
                                  )
                                );
                              }}
                            />
                          </Grid>
                        )}
                      </Grid>
                    )}
                  </Grid>

                  <Grid item className={classes.autocomplete}>
                    <GenericForm
                      fields={values}
                      screenFields={applyI18n([screenFields[5]], i18n.language)}
                      setFieldValue={(key, value) => {
                        setFieldValue(
                          'active_directory.ldap_type',
                          initial.active_directory
                        );
                        setFieldValue(key, value);
                      }}
                      errors={errors}
                      overrideClasses={{
                        selectLabel: { fontSize: 12, fontWeight: 500 },
                      }}
                    />
                    {['external', 'managed'].includes(
                      values?.active_directory.ldap_type
                    ) && (
                      <Grid container className={classes.configAD}>
                        <Paper elevation={2} className={classes.root}>
                          <DialogTitle className={classes.header}>
                            {`Active Directory: ${i18n.t(
                              values?.active_directory.ldap_type === 'external'
                                ? 'EXTERNAL_KEY'
                                : 'MANAGED_KEY'
                            )}`}
                            <Tooltip title={i18n.t('LDAP_TOOLTIP_KEY')}>
                              <HelpIcon fontSize="small" />
                            </Tooltip>
                          </DialogTitle>
                          <DialogContent dividers className={classes.content}>
                            <ADConfigFields
                              errors={errors}
                              isEdit={isEdit}
                              formValues={values}
                              partnerValues={initialValues}
                              setFieldValue={setFieldValue}
                            />
                            {values?.active_directory.ldap_type ===
                              'external' && (
                              <Grid
                                item
                                xs={12}
                                className={classes.switchPasswordChange}
                              >
                                <SwitchComponent
                                  borderText={i18n.t('PASSWORD_MANAGEMENT_KEY')}
                                  id="toggle-change-password"
                                  label={
                                    <Typography className={classes.useNewFront}>
                                      {i18n.t('MANAGE_CHANGE_PASSWORD_KEY')}
                                    </Typography>
                                  }
                                  onChange={(e, value) => {
                                    setFieldValue(
                                      'active_directory.can_external_ad_change_password',
                                      !!value
                                    );
                                  }}
                                  isChecked={
                                    values?.active_directory
                                      .can_external_ad_change_password === true
                                  }
                                />
                              </Grid>
                            )}
                          </DialogContent>

                          <DialogActions className={classes.footer}>
                            <Permission value="can_test_ldap">
                              <Button
                                disabled={ldapLoading}
                                id="test-button"
                                onClick={() =>
                                  handleTestLDAP(values?.active_directory)
                                }
                                className={classes.buttonTest}
                              >
                                {ldapLoading ? (
                                  <Loading size={15} />
                                ) : (
                                  i18n.t('TEST_KEY')
                                )}
                              </Button>
                            </Permission>
                            <Button
                              id="clear-button"
                              onClick={() => {
                                setFieldValue(
                                  'active_directory.ldap_server',
                                  ''
                                );
                                setFieldValue(
                                  'active_directory.admin_bind_dn',
                                  ''
                                );
                                setFieldValue('active_directory.base_dn', '');
                                setFieldValue('active_directory.ad_domain', '');
                                setFieldValue(
                                  'active_directory.ldap_server_backup',
                                  ''
                                );
                              }}
                            >
                              {i18n.t('CLEAR_FORM_KEY')}
                            </Button>
                          </DialogActions>
                        </Paper>
                      </Grid>
                    )}
                  </Grid>

                  <Grid item xs={6}>
                    <UseNewFrontConfiguration
                      isEdit={isEdit}
                      values={values}
                      setFieldValue={setFieldValue}
                      setHasError={setHasNewFrontMigrationError}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Grid
                      container
                      justify="space-between"
                      style={{ height: '100%', gap: '20px' }}
                    >
                      <Grid container>
                        {(role === RolesEnum.superAdmin ||
                          role === RolesEnum.admin) && (
                          <SwitchComponent
                            borderText="Salt"
                            id="toggle-salt"
                            label={
                              <Typography className={classes.useNewFront}>
                                {i18n.t('SALT.FALSE_ACTIVATE_SALT_KEY')}
                              </Typography>
                            }
                            onChange={(e, value) => {
                              setFieldValue(
                                'active_directory.ad_password_salt_enabled',
                                !!value
                              );
                              modalOpen({
                                title: !value
                                  ? i18n.t('SALT.TRUE_ACTIVATE_SALT_KEY')
                                  : i18n.t('SALT.FALSE_ACTIVATE_SALT_KEY'),
                                content: (
                                  <Typography className={classes.useNewFront}>
                                    {value
                                      ? i18n.t(
                                          'SALT.WARNING_FALSE_ACTIVATE_SALT_KEY'
                                        )
                                      : i18n.t(
                                          'SALT.WARNING_TRUE_ACTIVATE_SALT_KEY'
                                        )}
                                  </Typography>
                                ),
                                maxWidth: 'sm',
                                genericFooter: {
                                  action: () => {
                                    modalClose();
                                  },
                                  label: 'Ok',
                                },
                              });
                            }}
                            isChecked={
                              !!values?.active_directory
                                .ad_password_salt_enabled
                            }
                          />
                        )}
                      </Grid>
                      <Grid container>
                        {(role === RolesEnum.superAdmin ||
                          role === RolesEnum.admin) && (
                          <SwitchComponent
                            borderText={i18n.t('PARTNER_PAGE.SSO_KEY')}
                            id="toggle-sso"
                            label={
                              <Typography className={classes.useNewFront}>
                                {i18n.t('PARTNER_PAGE.SSO_DEACTIVATED_TOGGLE')}
                              </Typography>
                            }
                            onChange={(e, value) => {
                              setFieldValue('allow_sso_configuration', !!value);
                            }}
                            isChecked={values?.allow_sso_configuration === true}
                          />
                        )}
                      </Grid>
                      <Grid container>
                        <SwitchComponent
                          borderText={i18n.t('PARTNER_PAGE.DUO_KEY')}
                          id="toggle-duo"
                          label={
                            <Typography className={classes.useNewFront}>
                              {i18n.t('PARTNER_PAGE.DUO_DEACTIVATED_TOGGLE')}
                            </Typography>
                          }
                          onChange={(e, value) => {
                            setFieldValue('allow_duo_configuration', !!value);
                          }}
                          isChecked={values?.allow_duo_configuration === true}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <GenericForm
                      fields={values}
                      screenFields={applyI18n([screenFields[7]], i18n.language)}
                      setFieldValue={(key, value) => {
                        setFieldValue('email.from', '');
                        setFieldValue('email.domain', '');
                        setFieldValue('email.subject', '');
                        setFieldValue(key, value);
                      }}
                      errors={errors}
                      overrideClasses={{
                        selectLabel: { fontSize: 12, fontWeight: 500 },
                      }}
                    />
                    {String(values?.use_email) === 'true' && (
                      <Grid container>
                        <FormBox
                          onError={value => setBoxError(value)}
                          onField
                          title={i18n.t('EMAIL_KEY')}
                          fields={applyI18n(emailFields, i18n.language)}
                          initialValues={{
                            email_from: values?.email.from,
                            email_domain: values?.email.domain,
                            email_subject: values?.email.subject,
                          }}
                          onSubmit={val => {
                            setValueFormBox(setFieldValue, {
                              email: {
                                from: val.email_from,
                                domain: val.email_domain,
                                subject: val.email_subject,
                              },
                            });
                          }}
                          onCancel={() => {
                            setFieldValue('email.from', '');
                            setFieldValue('email.domain', '');
                            setFieldValue('email.subject', '');
                            setFieldValue('use_email', false);
                          }}
                        />
                      </Grid>
                    )}
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <GenericForm
                      fields={values}
                      screenFields={applyI18n([screenFields[8]], i18n.language)}
                      setFieldValue={(key, value) => {
                        setFieldValue('plugin.url_plugin', '');
                        setFieldValue('plugin.url_return', '');
                        setFieldValue(key, value);
                      }}
                      errors={errors}
                      overrideClasses={{
                        selectLabel: { fontSize: 12, fontWeight: 500 },
                      }}
                    />
                    {String(values?.use_plugin) === 'true' && (
                      <Grid container>
                        <FormBox
                          onError={value => setBoxError(value)}
                          onField
                          title="Plugin"
                          fields={applyI18n(pluginFields, i18n.language)}
                          initialValues={{
                            url_plugin: values?.plugin.url_plugin,
                            url_return: values?.plugin.url_return,
                          }}
                          onSubmit={val => {
                            setValueFormBox(setFieldValue, {
                              plugin: {
                                url_plugin: val.url_plugin,
                                url_return: val.url_return,
                              },
                            });
                          }}
                          onCancel={() => {
                            setFieldValue('plugin.url_plugin', '');
                            setFieldValue('plugin.url_return', '');
                            setFieldValue('use_plugin', false);
                          }}
                        />
                      </Grid>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6} className={classes.switch}>
                    <SwitchComponent
                      borderText={i18n.t('LICENSE_MANAGEMENT_KEY')}
                      id="toggle-manage_licenses"
                      label={
                        <Typography className={classes.useNewFront}>
                          {i18n.t('MANAGE_ENV_LICENSE_LIMIT_KEY')}
                        </Typography>
                      }
                      onChange={(e, value) => {
                        setFieldValue('enforce_env_license_limit', !!value);
                      }}
                      isChecked={values?.enforce_env_license_limit === true}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} className={classes.switch}>
                    <SwitchComponent
                      borderText={'reCAPTCHA'}
                      id="toggle-recaptcha"
                      label={
                        <Typography className={classes.useNewFront}>
                          {i18n.t('DISABLE_RECAPTCHA_TOGGLE_KEY')}
                        </Typography>
                      }
                      onChange={() => {
                        setFieldValue(
                          'recaptcha.enabled',
                          !values?.recaptcha?.enabled
                        );
                        if (values?.recaptcha?.enabled) {
                          setFieldValue('recaptcha.reason', '');
                        }
                      }}
                      isChecked={!values?.recaptcha?.enabled}
                    />
                    {!values?.recaptcha?.enabled && (
                      <Grid item className={classes.disableRecaptchaBox}>
                        <DisableRecaptcha
                          isEdit={isEdit}
                          values={values}
                          errors={errors}
                          setFieldValue={setFieldValue}
                          isRecaptchaEnabled={initialValues?.recaptcha?.enabled}
                          currentReason={initialValues?.recaptcha?.reason}
                        />
                      </Grid>
                    )}
                  </Grid>

                  <Grid container justify="center" className={classes.buttons}>
                    <Grid item>
                      {isEdit && (
                        <Permission value="edit_user_theme_config">
                          <Button
                            startIcon={<PaletteIcon />}
                            variant="outlined"
                            id="custom-button"
                            className={classes.customButton}
                            onClick={() =>
                              history.push(`/partners/custom/front/${id}`)
                            }
                          >
                            {i18n.t('PARTNER_PAGE.CUSTOM_FRONT_PARTNER')}
                          </Button>
                        </Permission>
                      )}
                    </Grid>
                    <Grid item>
                      <Button
                        id="save-button"
                        type="submit"
                        onClick={submitForm}
                        isLoading={isLoading}
                        submitButton
                        disabled={
                          Object.keys(errors).length !== 0 ||
                          hasNewFrontMigrationError
                        }
                      >
                        {i18n.t('SAVE_KEY')}
                      </Button>
                      {isEdit && onDelete && (
                        <Permission value="delete_partner">
                          <Button
                            deleteButton
                            id="delete-button"
                            onClick={onDelete}
                          >
                            {i18n.t('REMOVE_KEY')}
                          </Button>
                        </Permission>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Formik>
          </Grid>
        </Grid>
      ) : (
        <Grid container className={classes.loadingContainer}>
          <Loading />
        </Grid>
      )}
    </>
  );
};

const mapStateToProps = ({
  authenticate: { companySelected, data },
  partners: { ldapLoading },
  companies: { isLoading, companyDetails },
}: ApplicationState) => ({
  loadingList: isLoading,
  companySelected,
  ldapLoading,
  role: data?.role,
  companyDetails,
});

export default connect(mapStateToProps, {
  getAllCompaniesRequest,
  modalOpen,
  modalClose,
  LDAPTestRequest,
})(FormPartner);
